import { useMemo } from 'react'
import { useUserData } from 'components/contexts/UserDataContext'

/**
 * Hook to check if the current user can place orders
 * Returns true if:
 * - User has no paid workspace (backwards compatibility - allow ordering) OR
 * - (User has a paid workspace AND
 *    User's member data in that workspace has canOrder === true OR
 *    User's member data not found - backwards compatibility)
 * Returns false if user has no base user data
 */
export const useCanUserOrder = (): boolean => {
  const { baseUserData, currentUserWorkspace } = useUserData()

  const canOrder = useMemo(() => {
    // If user has no base user data, they can't order
    if (!baseUserData) return false

    // If user has no paid workspace, fall back to backwards compatibility (allow ordering)
    if (!currentUserWorkspace) return true

    // Default to true if currentUserWorkspace.canOrder not found (backwards compatibility)
    return currentUserWorkspace.canOrder !== undefined ? currentUserWorkspace.canOrder : true
  }, [currentUserWorkspace, baseUserData])

  return canOrder
}
